<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <div  class="px-0">
        <v-card-title class="headline pl-4 py-2 pr-2">
          Nowy użytkownik
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <div v-if="!dialogBusy">
          <div
            ref="scrollContainer"
            class="scrollable-height">
            <v-alert
              v-model="error"
              class="ma-0"
              dismissible
              type="error"
            >
              {{errorMsg}}
            </v-alert>
            <div class="pt-4">

              <v-layout class="px-4" wrap>
                <v-flex xs12 md3>
                  <div class="body-2 grey--text pt-1">Rodzaj konta</div>
                </v-flex>
                <v-flex xs12 md9>
                  <v-radio-group
                    v-model="formData.role"
                    class="mt-0"
                    :type="'password'"
                    :error-messages="errors.collect('role')"
                    v-validate="'required'"
                    data-vv-name="role"
                    data-vv-as="rodzaju konta"
                    required
                  >
                    <v-layout wrap>
                      <v-flex v-for="(userRole, i) in roles" :key="i" xs12 md6 pr-2>
                        <v-radio
                          color="primary"
                          :label="userRole.name"
                          :value="userRole.id"
                        ></v-radio>
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <div class="px-4 pb-4" v-if="formData.role && formData.role === 'client'">
                <v-select
                  v-model="formData.client_id"
                  :items="clients"
                  item-text="name"
                  item-value="id"
                  label="Wybierz klienta"
                  class="mt-0"
                  :error-messages="errors.collect('client_id')"
                  data-vv-name="client_id"
                  data-vv-as="klienta"
                  required
                ></v-select>
              </div>

              <v-divider></v-divider>

              <div class="px-4 pt-4">
                <div class="body-2 grey--text">Dane użytkownika</div>
              </div>

              <div class="px-4">
                <v-text-field
                  v-model.trim="formData.first_name"
                  label="Imię"
                  :error-messages="errors.collect('first_name')"
                  v-validate="'required'"
                  data-vv-name="first_name"
                  data-vv-as="imię"
                  required
                ></v-text-field>
              </div>
              <div class="px-4">
                <v-text-field
                  v-model="formData.last_name"
                  label="Nazwisko"
                  :error-messages="errors.collect('last_name')"
                  v-validate="'required'"
                  data-vv-name="last_name"
                  data-vv-as="nazwisko"
                  required
                ></v-text-field>
              </div>
              <div class="px-4 pb-2">
                <v-text-field
                  v-model.trim="formData.email"
                  label="Adres e-mail"
                  :error-messages="errors.collect('email')"
                  v-validate="'required|email'"
                  data-vv-name="email"
                  data-vv-as="e-mail"
                  required
                ></v-text-field>
              </div>

              <v-divider></v-divider>

              <div class="px-4 pt-4">
                <div class="body-2 grey--text">Dane autentykacyjne</div>
              </div>
              <div class="px-4">
                <v-text-field
                  v-model.trim="formData.pin"
                  label="Kod PIN"
                  autocomplete="new-password"
                  :error-messages="errors.collect('pin')"
                  :type="pinVisibility ? 'text' : 'password'"
                  :append-icon="pinVisibility ? 'visibility_off' : 'visibility'"
                  data-vv-name="pin"
                  v-validate="'required|max:10|min:6|alpha_num'"
                  @click:append="pinVisibility = !pinVisibility"
                  @keyup="setPinPresed"
                  data-vv-as="pin"
                  required
                ></v-text-field>
              </div>
              <div class="px-4">
                <v-text-field
                  ref="password"
                  v-model.trim="formData.password"
                  label="Hasło"
                  :type="'password'"
                  data-vv-delay="1000"
                  :error-messages="errors.collect('password')"
                  v-validate="'required|min:6|max:20'"
                  data-vv-name="password"
                  data-vv-as="hasło"
                  hint="Hasło musi mieć od 6 do 20 znaków, musi zawierać co najmniej:
              jedną małą literę, jedną wielką literę, jedną liczbę oraz jeden znak specjalny"
                  required
                ></v-text-field>
              </div>
              <div class="px-4 pb-2">
                <v-text-field
                  v-model.trim="formData.password_confirmation"
                  label="Powtórz hasło"
                  :type="'password'"
                  data-vv-delay="1000"
                  :error-messages="errors.collect('password_confirmation')"
                  v-validate="'confirmed:password'"
                  data-vv-name="password_confirmation"
                  data-vv-as="hasło"
                  required
                ></v-text-field>
              </div>

              <v-divider></v-divider>

              <div class="px-4 pt-4">
                <div class="body-2 grey--text">Google Drive</div>
              </div>
              <div class="px-4">
                <v-text-field
                  v-model.trim="formData.gd_client_id"
                  label="Client ID"
                  v-validate="'max:100'"
                  :error-messages="errors.collect('gd_client_id')"
                  data-vv-name="gd_client_id"
                  data-vv-as="client ID"
                ></v-text-field>
              </div>

              <div class="px-4">
                <v-text-field
                  v-model.trim="formData.gd_client_secret"
                  label="Client Secret"
                  v-validate="'max:30'"
                  :error-messages="errors.collect('gd_client_secret')"
                  data-vv-name="gd_client_secret"
                  data-vv-as="client secret"
                ></v-text-field>
              </div>

              <div class="px-4">
                <v-text-field
                  v-model.trim="formData.gd_refresh_token"
                  label="Refresh Token"
                  v-validate="'max:130'"
                  :error-messages="errors.collect('gd_refresh_token')"
                  data-vv-name="gd_refresh_token"
                  data-vv-as="refresh token"
                ></v-text-field>
              </div>

              <div class="px-4 pb-2">
                <v-text-field
                  v-model.trim="formData.gd_folder_id"
                  label="Folder ID"
                  v-validate="'max:50'"
                  :error-messages="errors.collect('gd_folder_id')"
                  data-vv-name="gd_folder_id"
                  data-vv-as="folder ID"
                ></v-text-field>
              </div>

              <v-divider></v-divider>

              <v-layout class="px-4 pt-4" wrap>
                <v-flex xs12 md3>
                  <div class="body-2 grey--text pt-1">Aktywny</div>
                </v-flex>
                <v-flex xs12 md9>
                  <v-radio-group
                    v-model="formData.status"
                    class="mt-0"
                    :type="'password'"
                    :error-messages="errors.collect('status')"
                    v-validate="'required'"
                    data-vv-name="status"
                    data-vv-as="statusu"
                    required
                  >
                    <v-layout wrap>
                      <v-flex xs12 md6 pr-2>
                        <v-radio
                          color="primary"
                          :label="'Aktywny'"
                          :value="1"
                        ></v-radio>
                      </v-flex>
                      <v-flex xs12 md6 pr-2>
                        <v-radio
                          color="primary"
                          :label="'Nieaktywny'"
                          :value="0"
                        ></v-radio>
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="pa-4">
            <ServerErrors :errorsItems="serverErrors" />

            <v-spacer></v-spacer>

            <v-btn
              color="primary lighten-2"
              flat="flat"
              @click="setVisbility"
            >
              Anuluj
            </v-btn>

            <v-btn
              color="primary"
              :loading="busy"
              :disabled="busy"
              @click="storeUser"
            >
              Dodaj
            </v-btn>
          </v-card-actions>
        </div>
        <div v-if="dialogBusy">
          <div class="py-4 text-xs-center">
            <v-progress-circular
              :size="30"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getError } from '../../../helpers/helpers';
import { getAddFormData } from '../../../repository/users/index';
import ServerErrors from '../../common/Errors/ServerErrors.vue';

export default {
  name: 'user-add-dialog',
  components: {
    ServerErrors,
  },
  data: () => ({
    pinPressed: false,
    pinVisibility: false,
    busy: false,
    dialogBusy: true,
    clients: null,
    roles: null,
    errorMsg: null,
    error: null,
    serverErrors: [],
    formData: {
      status: 1,
      role: null,
      first_name: null,
      last_name: null,
      client_id: null,
      pin: null,
      email: null,
      password: null,
      password_confirmation: null,
      gd_client_id: null,
      gd_client_secret: null,
      gd_refresh_token: null,
      gd_folder_id: null,
    },
  }),
  computed: {
    ...mapGetters('users', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'add';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('users', [
      'setDialogVisbility',
      'storeNewUser',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    getFormData() {
      this.getAddUserData();
    },
    clearData() {
      this.$validator.reset();
      this.pinVisibility = false;
      this.busy = false;
      this.dialogBusy = true;
      this.clients = null;
      this.roles = null;
      this.errorMsg = null;
      this.error = null;
      this.formData = {
        status: 1,
        role: null,
        first_name: null,
        last_name: null,
        client_id: null,
        pin: null,
        email: null,
        password: null,
        password_confirmation: null,
        gd_client_id: null,
        gd_client_secret: null,
        gd_refresh_token: null,
        gd_folder_id: null,
      };
    },
    setPinPresed() {
      this.pinPressed = true;
    },
    getServerErrors(errors) {
      const filedKeys = Object.keys(errors);
      filedKeys.forEach((fieldKey) => {
        const fieldErros = errors[fieldKey];
        if (!fieldErros[0] || fieldErros.length <= 0) return;
        fieldErros.forEach((err) => {
          const field = this.$validator.fields.find({
            name: fieldKey,
            scope: this.$options.scope,
          });
          if (field) {
            this.$validator.errors.add({
              id: field.id,
              field: fieldKey,
              msg: err,
              scope: this.$options.scope,
            });
            field.setFlags({
              invalid: true,
              valid: false,
              validated: true,
            });
          } else if (!this.serverErrors.includes(err)) {
            this.serverErrors.push(err);
          }
        });
      });
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
      this.$refs.scrollContainer.scrollTo(0, 0);
      if (errorData.response.data && errorData.response.data.data) {
        this.getServerErrors(errorData.response.data.data);
      }
    },
    async getAddUserData() {
      this.dialogBusy = true;
      try {
        const formRes = await getAddFormData();
        const formData = formRes.data.data;
        this.dialogBusy = false;
        this.roles = formData.roles;
        this.clients = formData.clients;
      } catch (e) {
        this.getError(e);
      }
    },
    setPin(id) {
      const pin = this.clients.find(client => client.id === id);
      if (pin && (!this.formData.pin || !this.pinPressed)) {
        this.formData.pin = pin.pin;
      }
    },
    storeUser() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addNewUser();
        }
      });
    },
    async addNewUser() {
      this.busy = true;
      try {
        await this.storeNewUser(this.formData);
        this.busy = false;
        this.setDialogVisbility(false);
      } catch (e) {
        this.getError(e);
      }
    },
    watchDat() {
      this.$watch('formData.client_id', (newVal) => {
        this.setPin(newVal);
      });
    },
  },
  created() {
    this.watchDat();
  },
  watch: {
    visibility(val, oldVal) {
      if (val === true) {
        this.getFormData();
        this.clearData();
      }
      if (oldVal) {
        this.clearData();
      }
    },
    formData: {
      handler(newData) {
        if (newData.role !== 'client') {
          this.formData.client_id = null;
        }
      },
      deep: true,
    },
  },
};
</script>
